import { AlphaKCircleOutlineIcon } from './AlphaKCircleOutlineIcon';

/**
 * author: Contributors
 * id F4E2D505-4C0D-4184-9F62-FDD7A450F6E7
 * name alpha-k-circle-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-k-circle-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetKCircleOutlineIcon = AlphaKCircleOutlineIcon;
export default AlphabetKCircleOutlineIcon